(() => {
  'use strict';

  const ajaxUrl = (route) => (route.endsWith('.js') ? route : `${route}.js`);

  const formatCurrency = (cents, currency = 'PLN') => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'pl-PL', {
        style: 'currency',
        currency
      }).format((Number(cents) || 0) / 100);
    } catch (error) {
      return `${((Number(cents) || 0) / 100).toFixed(2)} ${currency}`;
    }
  };

  const updateCartCount = (count) => {
    document.querySelectorAll('.cart-button').forEach((button) => {
      const previousCount = button.dataset.cartCount || '0';
      const label = button.getAttribute('aria-label') || '';
      button.dataset.cartCount = String(count);
      button.setAttribute('aria-label', label.replace(previousCount, String(count)));
    });
  };

  const ensurePageInteractive = () => {
    window.NNLReleasePage?.();
    document.body.classList.remove('drawer-open', 'intro-active');
    document.body.style.removeProperty('overflow');
    document.documentElement.style.removeProperty('overflow');
    document.documentElement.classList.add('nnl-intro-skip', 'nnl-page-released');
    document.querySelectorAll('[data-drawer].is-open').forEach((drawer) => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
    });
    document.querySelectorAll('[data-drawer-open][aria-expanded="true"]').forEach((button) => {
      button.setAttribute('aria-expanded', 'false');
    });
    document.querySelector('[data-intro]')?.remove();
  };

  const keepPageInteractive = () => {
    ensurePageInteractive();
    window.requestAnimationFrame(ensurePageInteractive);
    window.setTimeout(ensurePageInteractive, 180);
    window.setTimeout(ensurePageInteractive, 700);
  };

  const removeCartItem = async (link) => {
    if (!link || link.dataset.pending === 'true') return;

    const item = link.closest('[data-cart-item]');
    const key = link.dataset.cartKey || item?.dataset.cartKey;
    if (!key) return;

    link.dataset.pending = 'true';
    link.setAttribute('aria-disabled', 'true');

    try {
      const response = await fetch(ajaxUrl(window.NNL.routes.cartChange), {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ id: key, quantity: 0 })
      });
      const cart = await response.json().catch(() => ({}));

      if (!response.ok) {
        throw new Error(cart.description || cart.message || window.NNL.strings.error);
      }

      item?.remove();
      updateCartCount(cart.item_count || 0);

      const subtotal = document.querySelector('[data-cart-subtotal]');
      if (subtotal) {
        subtotal.textContent = formatCurrency(cart.total_price, cart.currency || 'PLN');
      }

      document.querySelectorAll('[data-cart-item]').forEach((cartItem) => {
        const updatedItem = (cart.items || []).find((entry) => entry.key === cartItem.dataset.cartKey);
        if (!updatedItem) return;

        const quantity = cartItem.querySelector('input[name="updates[]"]');
        const linePrice = cartItem.querySelector('[data-cart-line-price]');
        if (quantity) quantity.value = String(updatedItem.quantity);
        if (linePrice) {
          linePrice.textContent = formatCurrency(updatedItem.final_line_price, cart.currency || 'PLN');
        }
      });

      if ((cart.item_count || 0) === 0) {
        document.querySelector('[data-cart-page] .cart-page__form')?.remove();
        const template = document.querySelector('[data-cart-empty-template]');
        const container = document.querySelector('[data-cart-page] .page-width');
        if (template && container) {
          container.append(template.content.cloneNode(true));
        }
      }

      keepPageInteractive();
      document.dispatchEvent(new CustomEvent('nnl:cart-updated', { detail: cart }));
    } catch (error) {
      link.dataset.pending = 'false';
      link.removeAttribute('aria-disabled');
      window.NNLShowToast?.(error.message || window.NNL.strings.error);
      keepPageInteractive();
    }
  };

  window.NNLRemoveCartItem = removeCartItem;

  if (window.NNLPendingCartRemoval?.isConnected) {
    removeCartItem(window.NNLPendingCartRemoval);
    window.NNLPendingCartRemoval = null;
  }
})();
